type RafQueueCallback = () => boolean

export class RAFQueue {
    private queue: RafQueueCallback[]
    private running: boolean

    constructor() {
        this.queue = []
        this.running = false
    }

    /**
     * @public
     * @param {Function} callback
     */
    add(callback: RafQueueCallback): void {
        if (!(callback instanceof Function)) {
            return
        }

        this.queue.push(callback)

        if (!this.running) {
            this.loop()
        }
    }

    /**
     * @public
     * @param {number} index
     */
    remove(index: number): void {
        if (!this.queue[index]) {
            return
        }

        this.queue.splice(index, 1)
    }

    /**
     * @private
     */
    loop(): void {
        if (this.queue.length > 0) {
            this.requestAnimationFrame.call(window, this.loop.bind(this))
        }

        this.queue.forEach(this.callQueueItem.bind(this))
    }

    /**
     * @private
     * @param {Function} item
     * @param {number} index
     */
    callQueueItem(item: RafQueueCallback, index: number): void {
        if (true === item.call(this)) {
            this.remove(index)
        }
    }

    /**
     * @private
     * @type {Function}
     * @property {Function} callback
     */
    requestAnimationFrame = (() =>
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        ((callback: () => void) => {
            window.setTimeout(callback, 1000 / 60)
        }))()
}
